// Who is in which SubKrewe, worked out from the member records in memory
// (stores/adminLive.ts), instead of a query per SubKrewe.

/**
 * Each SubKrewe's members: everyone whose record points at it, captains and
 * red shirts included (as loadSubkreweMembers counted them). Only the
 * SubKrewes in `only`, when given.
 */
export function membersBySubkrewe(
  memberSubkrewe: ReadonlyMap<string, string | null>,
  only?: ReadonlySet<string>,
): Map<string, string[]> {
  const rosters = new Map<string, string[]>()
  for (const id of only ?? []) rosters.set(id, [])
  for (const [memberId, subkreweId] of memberSubkrewe) {
    if (!subkreweId || (only && !only.has(subkreweId))) continue
    const roster = rosters.get(subkreweId)
    if (roster) roster.push(memberId)
    else rosters.set(subkreweId, [memberId])
  }
  return rosters
}

/** The SubKrewes a member's change shows up in: before, after, and any they captain */
export function subkrewesTouchedBy(
  memberId: string,
  before: string | null | undefined,
  after: string | null | undefined,
  captainIds: ReadonlyMap<string, readonly string[]>,
): string[] {
  const touched = new Set<string>()
  if (before) touched.add(before)
  if (after) touched.add(after)
  for (const [subkreweId, captains] of captainIds) {
    if (captains.includes(memberId)) touched.add(subkreweId)
  }
  return [...touched]
}
